import { createStore } from 'vuex'
import auth from './modules/auth'
import chats from './modules/chats'

export default createStore({
  modules: {
    auth,
    chats,
  },
})
